import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fs-page" }
const _hoisted_2 = { class: "fs-inner" }
const _hoisted_3 = { class: "hero" }
const _hoisted_4 = { class: "hero-actions" }
const _hoisted_5 = {
  key: 1,
  class: "empty-card"
}
const _hoisted_6 = {
  key: 2,
  class: "viewer-card"
}
const _hoisted_7 = { class: "viewer-head" }
const _hoisted_8 = { class: "viewer-body" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 2,
  class: "viewer-placeholder"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "hero-txt" }, [
          _createElementVNode("div", { class: "hero-eyebrow" }, "PORTAL HR"),
          _createElementVNode("h1", { class: "hero-title" }, "Fluturaș de salariu"),
          _createElementVNode("p", { class: "hero-sub" }, "Selectează luna și vizualizează fluturașul tău de salariu.")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_select, {
            modelValue: _ctx.lunaSelectata,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lunaSelectata) = $event)),
            items: _ctx.luni,
            "item-title": "text",
            "item-value": "val",
            label: "Luna",
            variant: "solo",
            density: "compact",
            "hide-details": "",
            "bg-color": "white",
            style: {"min-width":"200px"},
            disabled: _ctx.loadingLuni || _ctx.luni.length === 0
          }, null, 8, ["modelValue", "items", "disabled"]),
          _createVNode(_component_v_btn, {
            class: "btn-nou",
            "prepend-icon": "mdi-eye-outline",
            loading: _ctx.loadingPdf,
            disabled: !_ctx.lunaSelectata,
            onClick: _ctx.vizualizeaza
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Vizualizează ", -1)
            ]))]),
            _: 1
          }, 8, ["loading", "disabled", "onClick"]),
          _createVNode(_component_v_btn, {
            class: "btn-ghost",
            "prepend-icon": "mdi-download",
            disabled: !_ctx.pdfUrl,
            onClick: _ctx.descarca
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" Descarcă ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ]),
      (_ctx.eroare)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 0,
            type: "error",
            variant: "tonal",
            class: "mb-4",
            closable: "",
            "onClick:close": _cache[1] || (_cache[1] = ($event: any) => (_ctx.eroare = ''))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.eroare), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.loadingLuni && _ctx.luni.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_v_icon, {
              size: "42",
              color: "#ff5722"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("mdi-cash-remove", -1)
              ]))]),
              _: 1
            }),
            _cache[6] || (_cache[6] = _createElementVNode("p", null, "Nu există calcule de salariu disponibile pentru contul tău.", -1))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_v_icon, {
                size: "18",
                color: "#ff5722",
                class: "mr-2"
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("mdi-file-pdf-box", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("span", null, "Fluturaș " + _toDisplayString(_ctx.lunaLabel), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.loadingPdf)
                ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                    key: 0,
                    indeterminate: "",
                    color: "#ff5722"
                  }))
                : _createCommentVNode("", true),
              (_ctx.pdfUrl)
                ? (_openBlock(), _createElementBlock("iframe", {
                    key: 1,
                    src: _ctx.pdfUrl,
                    class: "pdf-frame",
                    title: "Fluturaș de salariu"
                  }, null, 8, _hoisted_9))
                : (!_ctx.loadingPdf)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_v_icon, {
                        size: "42",
                        color: "#cbd5e1"
                      }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode("mdi-file-eye-outline", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[9] || (_cache[9] = _createElementVNode("p", null, "Alege o lună și apasă „Vizualizează\".", -1))
                    ]))
                  : _createCommentVNode("", true)
            ])
          ]))
    ])
  ]))
}